import React from 'react';
import { ChevronDown } from 'lucide-react';

const GenericHero = ({ title, description, backgroundImage, backgroundVideo, height = "h-screen md:h-[70vh]" }) => {
  return (
    <section className={`relative ${height} flex items-center justify-center overflow-hidden`}>
      <div className="absolute inset-0">
        {backgroundVideo ? (
          <>
            <video
              src={backgroundVideo}
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/50 to-black/50"></div>
          </>
        ) : (
          <>
            <img
              src={backgroundImage || "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"}
              alt="Hero Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/50 to-black/50"></div>
          </>
        )}
      </div>

      <div className="absolute left-4 sm:left-8 md:left-12 lg:left-16 bottom-6 sm:bottom-10 z-10 text-left max-w-3xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-semibold title-font text-[#81be00] mb-3 sm:mb-4 leading-tight">
          {title}
        </h1>
        <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/75 font-light">
          {description}
        </p>
      </div>

      <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="flex flex-col items-center text-white">
          <div className="w-8 h-8 sm:w-10 sm:h-10 border border-white flex items-center justify-center mb-1 sm:mb-2 hover:bg-white hover:text-black transition-all duration-300 cursor-pointer">
            <ChevronDown size={16} className="sm:size-5" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenericHero;
